/* global globals, mapboxgl */
import { find, get, getParameterByName } from './utils';

function getMarkerImage(markerType) {
    const imagePath = name => `${ globals.staticUrl }img/map-legend/${name}.png`;
    const imageTypes = {
        library: 'book',
        theatre: 'masks',
        pitch: 'runner',
    };

    return imagePath(imageTypes[markerType]);
}

function getActiveMarkerID() {
    return getParameterByName('marker_id');
}

function createMap() {
    return new mapboxgl.Map({
        style: 'mapbox://styles/zuerichunbezahlbar/cjoe3issz8m5j2rmiqqr1kewg',
        container: 'map',
        center: [8.5272144, 47.3782611],
        zoom: 14.0,
    });
}

function addMarker(map, marker, activeMarkerID) {
    const el = document.createElement('div');

    el.className = `marker ${ activeMarkerID === marker.id ? 'marker__active' : '' }`;
    el.style.backgroundImage = `url(${ getMarkerImage(marker.properties['marker-symbol']) })`;

    el.addEventListener('click', function() {
        openOverlay(marker.properties.url);
    });

    // add marker to map
    return new mapboxgl.Marker(el)
        .setLngLat(marker.geometry.coordinates)
        .addTo(map);
}

function setupMap(map, markers, activeMarkerID) {
    const marker = activeMarkerID && find(markers, marker => activeMarkerID === marker.id);

    if (marker) {
        map.flyTo({ center: marker.geometry.coordinates, zoom: 14 });
    } else {
        map.fitBounds(getMarkerBounds(markers));
    }

    return map;
}

/* Use overlay.js as soon as someone gets explicit imports to work */
function openOverlay(url) {
    var $modal = $('<div data-reveal>').addClass('reveal-modal').appendTo('body');
    $.get(url, function(data) {
        $modal.empty().html($(data).find('#main'))
            .append('<a class="close-reveal-modal">&#215;</a>')
            .foundation('reveal', 'open', { animation: 'fade' });

        $(document).trigger('overlay:loaded');
    });
}

function initMap() {
    mapboxgl.accessToken = 'pk.eyJ1IjoienVlcmljaHVuYmV6YWhsYmFyIiwiYSI6ImNpcnhrc2w0MjAwMWMydHAyamhxZHF1a3QifQ.iDUMbu5Sr3qXozeNkQPH7g';
    const map = createMap();
    const activeMarkerID = getActiveMarkerID();

    return get(`/map/locations/${ window.location.search }`)
        .then(markers => {
            markers.forEach(marker => addMarker(map, marker, activeMarkerID));
            return markers;
        })
        .then(markers => setupMap(map, markers, activeMarkerID));
}

function getMarkerBounds(markers) {
    const bounds = new mapboxgl.LngLatBounds();

    markers.forEach(function(feature) {
        bounds.extend(feature.geometry.coordinates);
    });

    return bounds;
}

export default initMap;



// WEBPACK FOOTER //
// ./src/js/app/components/map/index.js